<div class="infoIcon" (click)="open()" #infoIcon>i</div>

<ng-template #cdkPortal>
  <div
    (glClickedOutside)="destroyTooltipComponent()"
    [elementToIgnore]="infoIconEl"
    class="infoWindow"
    #infoWindow
  >
    <div class="wrapper" #infoWrapper>
      <ng-content></ng-content>
    </div>
  </div>
</ng-template>
